export default "__VITE_ASSET__GAkiqI$F__"